/*
#################
## RadioButton ##
#################
Custom Radio button. Each one of parent container need to has an ID (required to focusAnimated prop)

* OPTIONS
    * profileModel[String]: Model of data. Required.
    * optionsList[Array]: List of options. Required.
    * Label: Show input name. Not required.
    * style[Object]: Add styles. Not required.
    * messagesError[Object]: Add messages errors. Not required.
    * IsRequired: For required field. Not Required. (Not implemented)

* EXAMPLE
    <RadioButton
        profileModel="userProfile.radioButtonOption"
        optionsList={[{
            label: 'Opción 1',
            value: 1
            additionalComponent: (<AdditionalComponent />) Adds an extra component to render below option when checked.
        },{
            label: 'Opción 2',
            value: 2
        },{
            label: 'Opción 3',
            value: 3
        }]}
        isRequired
        isUpdated = {function(){
            console.log("updated");
        }
        {...this.props}
    />

*/
// @ vendors
import { getValue } from 'utilities/helperFunctions';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { Errors } = require('react-redux-form');
// @ utilities
const scroll = require('utilities/scroll');
import { formatText } from 'core/i18n';

class RadioButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            classError: false,
            trigger: false,
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { userProfileForm, profileModel, model } = nextProps;
        const modelProp = model || profileModel.split('.')[1];

        if (userProfileForm && userProfileForm && userProfileForm[modelProp]) {
            this.changeClassError(!userProfileForm[modelProp].valid);
        }
    }

    componentDidUpdate() {
        if (this.state.trigger) {
            const { profileModel, isUpdated, userProfileForm, model } = this.props;
            let modelProp;

            if (profileModel) {
                modelProp = model || profileModel.split('.')[1];
            }

            if (userProfileForm && userProfileForm[modelProp].valid && isUpdated) {
                isUpdated();
            }

            this.changeTrigger(false);
        }
    }

    handleOnChange(evt) {
        const {
            target: { value },
        } = evt;
        const { formActions, profileModel, onChange } = this.props;

        formActions.change(profileModel, value);
        formActions.setValidity(profileModel, { required: true }); // Is valid if is selected.
        this.changeTrigger(true);

        if (onChange) {
            onChange(value);
        }
    }

    handleOnFocus() {
        const { focusAnimated, onFocus } = this.props;

        if (focusAnimated) {
            this.onFocusAnimate();
        }
        if (onFocus) {
            onFocus();
        }
    }

    onFocusAnimate() {
        const { profileModel, model } = this.props;
        const modelProp = model || profileModel.split('.')[1];
        const element = document.getElementById(`id_wrapper_${modelProp}`);

        if (element) {
            scroll.transition(element);
        }
    }

    changeClassError(change) {
        this.setState({
            classError: change,
        });
    }

    changeTrigger(trigger) {
        this.setState({
            trigger,
        });
    }

    getUserProfileValue() {
        const { userProfile, profileModel, model } = this.props;
        const modelArray = profileModel.split('.');
        const parent = modelArray[1];
        const rest = modelArray.slice(2);
        let value = userProfile[parent];

        if (value && model) {
            value = getValue(value, rest);
        }

        return value;
    }

    buildRadioButton() {
        const { optionsList, paymentStyle } = this.props;
        let dataToRender = null;

        if (optionsList.length) {
            const { onKeyDown, disabled, profileModel, model } = this.props;
            const modelProp = model || profileModel.split('.')[1];

            dataToRender = optionsList.map((option, i) => {
                const id = `${modelProp}_${i}`;
                const value = option.value;
                const additionalComponent = option.additionalComponent;
                const userProfileValue = this.getUserProfileValue();
                const checked = userProfileValue === value.toString();
                const shouldShowAdditionalComponent =
                    additionalComponent && (checked || option.showAlwaysAdditionalComponent);

                return (
                    <li key={id}>
                        <input
                            className="form__radio"
                            type="radio"
                            id={id}
                            name={modelProp}
                            defaultValue={value}
                            onChange={this.handleOnChange}
                            checked={checked}
                            onKeyDown={onKeyDown}
                            disabled={disabled}
                            onFocus={this.handleOnFocus}
                        />
                        <label className="sub-label" htmlFor={id} style={paymentStyle}>
                            {option.label}
                        </label>
                        <div className={`radio-additional-component ${shouldShowAdditionalComponent ? '' : 'd-none'}`}>
                            {additionalComponent}
                        </div>
                    </li>
                );
            });
        }

        return dataToRender;
    }

    renderErrors(props) {
        return <p className="form__field_error">{props.children}</p>;
    }

    render() {
        const { label, messagesError, profileModel, style, subtitle, tooltip, model } = this.props;
        const listClassName = classNames('form__radio-list', {
            'form__input--error valid-error': this.state.classError,
        });
        const showSubtitle = <label className="sub-label">{subtitle}</label>;
        const showLabel = (
            <label>
                {label}
                {tooltip}
            </label>
        );
        const modelProp = model || profileModel.split('.')[1];
        const radioViews = this.buildRadioButton();

        return (
            <div style={style} id={`id_wrapper_${modelProp}`}>
                {label && showLabel}
                {tooltip}
                {subtitle && showSubtitle}
                <ul className={listClassName}>{radioViews}</ul>
                <Errors model={profileModel} messages={messagesError} component={this.renderErrors} />
            </div>
        );
    }
}

RadioButton.propTypes = {
    disabled: PropTypes.bool,
    focusAnimated: PropTypes.bool,
    isUpdated: PropTypes.func,
    messagesError: PropTypes.object,
    onKeyDown: PropTypes.func,
    optionsList: PropTypes.arrayOf(
        PropTypes.shape({
            additionalComponent: PropTypes.node,
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
        })
    ),
    profileModel: PropTypes.string.isRequired,
    style: PropTypes.object,
    paymentStyle: PropTypes.object,
    model: PropTypes.string,
    onFocus: PropTypes.func,
};

RadioButton.defaultProps = {
    disabled: false,
    focusAnimated: false,
    messagesError: {
        required: formatText('validation-radioRequired'),
        valid: formatText('validation-text'),
    },
    onKeyDown: null,
    style: {},
    paymentStyle: {},
};
module.exports = RadioButton;
